import { Content } from "@/services/content/types";
import { ARTICLE_TYPES } from "@/services/content/utils";
import * as ArticleTeaser from "./article";
import * as InterviewTeaser from "./interview";
import * as HorizontalTeaser from "./play";
// import * as ChronicleTeaser from "./chronicle";
// import * as CommentTeaser from "./comment";
import * as PodcastTeaser from "./podcast";

type HorizontalProps = {
  item: Content.Entry;
  showLinkedContent?: boolean;
  fullWidth?: boolean;
};

const Horizontal = ({
  item,
  showLinkedContent = true,
  fullWidth = false,
}: HorizontalProps) => {
  if (
    item.sys.contentType.sys.id === "play" ||
    item.sys.contentType.sys.id === "play-episode"
  ) {
    return <HorizontalTeaser.horizontal play={item} />;
  }

  if (
    item.sys.contentType.sys.id === "article" ||
    item.sys.contentType.sys.id === "externalContent"
  ) {
    const type = (item as Content.Article).fields.type;

    if (type === ARTICLE_TYPES.CHRONICLE) {
      console.warn(
        `${item.sys.contentType.sys.id} horizontal teaser not implemented`
      );
    }

    if (type === ARTICLE_TYPES.INTERVIEW || type === ARTICLE_TYPES.REPORTAGE) {
      return (
        <InterviewTeaser.horizontal
          article={item}
          showLinkedContent={showLinkedContent}
          fullWidth={fullWidth}
        />
      );
    }

    if (type === ARTICLE_TYPES.ANALYSIS || type === ARTICLE_TYPES.COMMENT) {
      return (
        <ArticleTeaser.Horizontal
          article={item}
          showLinkedContent={showLinkedContent}
        />
      );
    }

    return (
      <ArticleTeaser.Horizontal
        article={item}
        showLinkedContent={showLinkedContent}
      />
    );
  }

  if (item.sys.contentType.sys.id == "podcast-show") {
  }

  if (item.sys.contentType.sys.id == "podcast-episode") {
    return <PodcastTeaser.horizontal episode={item} />;
  }

  console.warn(
    `${item.sys.contentType.sys.id} horizontal teaser not implemented`
  );

  return null;
};

export default Horizontal;
